<script>
export default {
  name: 'SelectedItemsDisplay',
  props: {
    selectedItemsValues: {
      type: Array,
      required: true,
      default: () => [],
    },
    defaultText: {
      type: String,
      default: 'Todos',
    },
  },
  computed: {
    hasNoItems() {
      return this.selectedItemsLength === 0
    },
    selectedItemsDisplayMessage() {
      return this.isSingleItemSelected
        ? this.firstSelectedItem
        : this.selectedItemsCountMessage
    },
    isSingleItemSelected() {
      return this.selectedItemsLength === 1
    },
    firstSelectedItem() {
      return this.selectedItemsValues[0]
    },
    selectedItemsCountMessage() {
      return `${this.selectedItemsLength} itens selecionados`
    },
    selectedItemsLength() {
      return this.selectedItemsValues.length
    },
  },
}
</script>

<template>
  <div class="selected-items truncate text-xs">
    <span v-if="hasNoItems">
      {{ defaultText }}
    </span>

    <span v-else>
      {{ selectedItemsDisplayMessage }}
    </span>
  </div>
</template>

<style lang="sass" scoped>
.selected-items
  min-width: 0
</style>
